import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { beloitConfig } from "./data";

export default function BeloitPage() {
  return <CityPageTemplate config={beloitConfig} />;
}